import cl from 'clsx'

import classes from './MainUrlInput.module.scss'
import { UseMainUrlInput } from './hook'
import { KeyboardEventHandler } from 'react'

export type MainUrlInputProps = {
    className?: string
    disabled: boolean
} & Pick<UseMainUrlInput, 'value' | 'onChange' | 'errorMessage' | 'onApply'>
export const MainUrlInput = ({
    className,
    disabled,
    value,
    onChange,
    onApply,
    errorMessage,
}: MainUrlInputProps) => {
    const onKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = (evt) => {
        switch (evt.key) {
            case 'Enter': {
                if (!errorMessage) {
                    evt.currentTarget.blur()
                }
                return
            }
        }
    }

    const onBlur = () => {
        if (!errorMessage) {
            onApply()
        }
    }

    return (
        <div
            className={cl(classes.root, className, {
                [classes.error]: errorMessage,
            })}
        >
            <textarea
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                disabled={disabled}
                spellCheck={false}
                className={classes.textarea}
                value={value}
                onChange={(evt) => onChange(evt.currentTarget.value)}
            />
            <div className={classes.errorMessage}>{errorMessage}</div>
        </div>
    )
}
